import { AxiosInstance } from 'axios'
import { AttendanceType, Gender, TeleconsultationOptions } from './_types'

export type Cnes = {
  id: number
  code: string
  name: string
}

export type Specialty = {
  id: number
  specialtyName: string
  subspecialtyName: string | null
  createdAt: Date
  updatedAt: Date
  deletedAt: Date | null
}

export type PhysicianProfile = {
  id: number
  name?: string
  email?: string
  gender: Gender | null
  mobile?: string
  birthday: string | null
  crmNumber?: string
  crmState?: string | null
  cpf?: string | null
  cns?: string
  specialties?:
    | {
        specialtyId: number
        specialty: Specialty
        rqe: string | null
      }[]
    | null
  attendanceAddresses: {
    name: string
    zipCode: string | null
    mobile: string | null
    phone: string | null
    street: string
    district: string
    number: string
    complement: string | null
    cityId: number
    city: {
      ibgeCode?: string
      id?: number
      text?: string
    }
    cnesCode?: string | null
    teleconsultation: TeleconsultationOptions
    attendanceType: AttendanceType[]
    attendancePrice: number | null
    healthPlans:
      | {
          id: number
          name: string | null
        }[]
      | null
  }[]
}

export function physicianEndpoints(apiClient: AxiosInstance) {
  return {
    listCnes(): Promise<Cnes[]> {
      return apiClient.get('options/cnes')
    },
    getPhysicianProfileInfo(): Promise<PhysicianProfile | null> {
      return apiClient.get(`get-physician-profile-info`)
    },
  }
}
